const linear = (timeFraction: number) => {
  return timeFraction;
};

const  quad = (timeFraction: number) => {
  return Math.pow(timeFraction, 2);
};

const makeEaseInOut = (timing: (value: number) => number) => {
  return (timeFraction: number) => {
    if (timeFraction < 0.5) {
      return timing(2 * timeFraction) / 2;
    }
    else {
      return (2 - timing(2 * (1 - timeFraction))) / 2;
    }
  }
};

export {linear, quad, makeEaseInOut};
